







import Vue from 'vue';
import Layout from '@/layouts/BaseLayout.vue';

export default Vue.extend({
    name: 'HomePage',
    components: {
        Layout
    },
});
